export const borderRadius = 4;
export const baseBorderRadius = "4px";
export const borderRadiusLarge = "6px";
export const zindexDropdown = 1000;
export const zindexPopover = 1010;
export const zindexTooltip = 1030;
export const zindexFixedNavbar = 1030;
export const zindexHeader = 1060;
export const zindexModalBackdrop = 1070;
export const zindexModal = 1080;
export const zindexAboveModal = 1090;
export const contentPadding = "20px";
export const minContainerWidth = "1000px";
export const maxContainerWidth = "1200px";
export const contentWidth = 688;
export const pageWidth = 1200;
export const contentModalWidth = 1024;
export const topBarHeightDesktop = 48;
export const topBarHeightMobile = 60;
export const pageHeaderHeight = 62;
export const pageHeaderHorizontalPadding = 20;
export const pageHeaderHorizontalPaddingMobile = 16;
export const standardTransitionMs = 200;
export const standardTransitionExtras = "ease-out";
export const standardTransition = `${
    standardTransitionMs / 1000
}s ${standardTransitionExtras}`;
